import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { AccessSections } from '../classes/user';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root'
})
export class SharedService {
    constructor(private userService: UserService){

    }
    private accessSubject = new BehaviorSubject<AccessSections>(null);
    private isLoaded = false;
    private user_role = new BehaviorSubject<number>(null);

    getAccess(): Observable<AccessSections> {
        return this.accessSubject.asObservable().pipe(
            filter(access => access !== null)
        );
    }

    setAccess(access: AccessSections): void {
        this.isLoaded = true;
        this.accessSubject.next(access);
    }

    isAccessLoaded(): boolean {
        return this.isLoaded;
    }

    clearAccess(): void {
        this.isLoaded = false;
        this.accessSubject.next(null);
    }
    getUserRole(): Observable<boolean> {
        return this.userService.getUserRole().pipe(
            map((role: any) => role.payload === 1)
        );
    }
    setUserRole(role: number): void{
        this.user_role.next(role);
    }
}